(function () {
    var formApp = angular.module('formApp');
    formApp.controller(
        'manageFeedbacksController',
        ['$scope', '$rootScope', '$http', '$location', '$timeout', 'uiGridConstants', 'Constants', 'DataServices', 'UtilityServices', 'adalAuthenticationService',
            function ($scope, $rootScope, $http, $location, $timeout, uiGridConstants, Constants, DataServices, UtilityServices, adalAuthenticationService) {

                $scope.utility = UtilityServices;
                $scope.Constants = Constants;

                // Reset values that are used while working with an incident so any new incident opened / edited has these values reset.
                DataServices.validationErrors = [];
                DataServices.resetResponseInfo();
                delete DataServices.callingPage;
                DataServices.incidentSubmitted = false;




                // $scope.utility.toggleClass($('header'), true, 'header_with-nav');

                $scope.totalRecords = 0;
                $scope.filteredRecords = 0;
                $scope.maxRecords = 0;
                $scope.hasMoreRecords = false;
                $scope.isTotalCountLoading = false;

                if ($location.path().indexOf('DH') > -1) {
                    $scope.IsDHVisible = true;
                    $scope.IsDFFHVisible = false;
                }
                else {
                    $scope.IsDHVisible = false;
                    $scope.IsDFFHVisible = true;
                }



                // Define filters
                if (!DataServices.miFilters) {
                    DataServices.miFilters = {
                        selectedFeedbackStatus: Constants.defaultFeedbackStatus,
                        selectedFinalRiskRating: '',
                        selectedArea: '',
                        selectedProgram: '',
                        selectedDateRange: Constants.defaultDateOption,
                        searchPhrase: '',
                        feedbackStatusList: [],
                        finalRiskRatingList: [],
                        areaList: [],
                        programList: [],
                        dateRangeList: []
                    };
                }
                $scope.filters = DataServices.miFilters;

                var iosOrMobile = /iphone|ipod|ipad|mobile/.test(window.navigator.userAgent.toLowerCase());

                document.title = Constants.Messages.manageReportsPageTitle;
                $scope.rowHeight = 56;
                $scope.getSubGridRowHeight = function (row) {
                    return Math.floor((row.entity.subGridOptions.data.length + 1) * $scope.rowHeight);
                }
                var getColumnDefs = function () {

                    // Determine whether we are running in extra small screen size (mobile phones)
                    // Angular UI grid uses JS to set width calculations, therefore it is not possible to hide the columns just using CSS.
                    var isRunningInExtraSmallScreen = $(document).width() < 768;

                    return [
                        {
                            field: 'statusDisplayName',
                            displayName: 'Status',
                            enableHiding: false,
                            width: isRunningInExtraSmallScreen ? '50%' : '8%',
                            enableColumnMenu: false
                        },
                        {
                            field: 'formattedRef',
                            displayName: 'Report Id',
                            enableHiding: false,
                            width: isRunningInExtraSmallScreen ? '50%' : '10%',
                            enableColumnMenu: false,
                            cellTemplate: '<div class="ui-grid-cell-contents">' +
                                '<div ng-class="{ \'exclamation\' : row.entity.isCritical }">' +
                                '{{COL_FIELD}}' +
                                '</div>' +
                                '</div>'
                        },
                        {
                            field: 'linkReveal',
                            displayName: 'Links',
                            enableHiding: false,
                            width: $scope.isRunningInExtraSmallScreen ? '0%' : '7%',
                            enableColumnMenu: false,
                            cellTemplate: '<div class="ui-grid-cell-contents">' +
                                '<i ng-if="row.entity.linkArray.length > 0 && !(row.groupHeader == true || row.entity.subGridOptions.disableRowExpandable)" ' +
                                'ng-class="{ \'ui-grid-icon-plus-squared\' : !row.isExpanded, \'ui-grid-icon-minus-squared\' : row.isExpanded }" ' +
                                'ng-click="grid.api.expandable.toggleRowExpansion(row.entity)" class="ng-scope ui-grid-icon-plus-squared" style="" > ' +
                                '</i> ' +
                                '{{row.entity.linkDisplayString}}' +
                                '</div>'
                        },
                        {
                            field: 'disclosedDate',
                            displayName: 'Disclosed Date',
                            cellFilter: 'date:\'dd/MM/yyyy\'',
                            enableHiding: false,
                            hideInSmallScreen: true,
                            width: isRunningInExtraSmallScreen ? '0%' : '8%',
                            enableColumnMenu: false,
                            cellClass: isRunningInExtraSmallScreen ? 'hidden-xs' : '',
                            headerCellClass: isRunningInExtraSmallScreen ? 'hidden-xs' : '',
                            sort: { direction: uiGridConstants.DESC }
                        },
                        {
                            field: 'clientName',
                            displayName: 'Person Names',
                            enableHiding: false,
                            hideInSmallScreen: true,
                            width: isRunningInExtraSmallScreen ? '0%' : '10%',
                            enableColumnMenu: false,
                            resizable: false,
                            cellClass: isRunningInExtraSmallScreen ? 'hidden-xs' : '',
                            headerCellClass: isRunningInExtraSmallScreen ? 'hidden-xs' : '',
                            cellTemplate: '<div class="ui-grid-cell-contents">' +
                                '<a class="badge badge-left" ng-if="row.entity.clientCount > 1" href="" ' +
                                'role="button" ' +
                                'aria-describedby="describeClientListLabel" ' +
                                'ng-touchend="grid.appScope.onClientExpandTouchend(row)" ' +
                                'ng-click="grid.appScope.onClientExpandClick(row)" >' +
                                '<span>+{{(row.entity.clientCount - 1)}}</span>' +
                                '</a>' +
                                ' {{COL_FIELD}}' +
                                '</div>'
                        },
                        {
                            field: 'areaDescription',
                            displayName: 'Area',
                            enableHiding: false,
                            width: isRunningInExtraSmallScreen ? '0%' : '12%',
                            enableColumnMenu: false
                        },
                        {
                            field: 'programDescription',
                            displayName: 'Program',
                            enableHiding: false,
                            width: isRunningInExtraSmallScreen ? '0%' : '12%',
                            enableColumnMenu: false
                        },
                        {
                            field: 'finalRiskRatingDescription',
                            displayName: 'Risk Rating',
                            enableHiding: false,
                            width: isRunningInExtraSmallScreen ? '0%' : '10%',
                            enableColumnMenu: false,
                            cellTemplate: '<div class="ui-grid-cell-contents">' +
                                '<span>{{COL_FIELD}}</span>' +
                                '<span ng-if="!!row.entity.initialRiskRatingDescription">&nbsp;<i>({{row.entity.initialRiskRatingDescription}})</i></span>' +
                                '</div>'
                        },
                        {
                            field: 'dueDate',
                            displayName: 'Due Date',
                            cellFilter: 'date:\'dd/MM/yyyy\'',
                            enableHiding: false,
                            hideInSmallScreen: true,
                            enableColumnMenu: false,
                            width: isRunningInExtraSmallScreen ? '0%' : '7%',
                            cellClass: isRunningInExtraSmallScreen ? 'hidden-xs' : '',
                            headerCellClass: isRunningInExtraSmallScreen ? 'hidden-xs' : ''
                        },
                        {
                            field: 'assignedTo',
                            displayName: 'Assigned To',
                            enableHiding: false,
                            width: isRunningInExtraSmallScreen ? '0%' : '16%',
                            enableColumnMenu: false
                        },
                        {
                            field: 'Toolbox',
                            displayName: 'Toolbox',
                            cellClass: 'manage__tools',
                            headerCellClass: 'manage__tools-hidden',
                            cellTemplate: $scope.IsDHVisible ?
                                // View
                                '<a style="color:rgb(198, 54, 99);" aria-label="View" title="View" ng-if="!row.entity.canEdit" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onViewOrEditTouchend(row)" ' +
                                'ng-click="grid.appScope.onViewOrEditClick(row)">' +
                                '<span ng-if="row.entity.isViewOrEditLoaded"><svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon icon_view">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-view">' +
                                '</use>' +
                                '</svg>' +
                                'View</span>' +
                                '<span class="sr-only">Opens dialog</span>' +
                                '<span ng-if="!row.entity.isViewOrEditLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // Edit
                                '<a style="color:rgb(198, 54, 99);" aria-label="Edit" title="Edit" ng-if="row.entity.canEdit" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onViewOrEditTouchend(row)" ' +
                                'ng-click="grid.appScope.onViewOrEditClick(row)">' +
                                '<span ng-if="row.entity.isViewOrEditLoaded"><svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon icon_edit">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-edit">' +
                                '</use>' +
                                '</svg>' +
                                'Edit</span>' +
                                '<span class="sr-only">Opens dialog</span>' +
                                '<span ng-if="!row.entity.isViewOrEditLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // Withdraw
                                '<a style="color:rgb(198, 54, 99);" aria-label="Withdraw" title="Withdraw" ng-if="row.entity.canWithdraw" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onWithdrawTouchend(row)" ' +
                                'ng-click="grid.appScope.onWithdrawClick(row)" >' +
                                '<span ng-if="row.entity.isWithdrawLoaded"><svg  focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon icon_delete">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-delete">' +
                                '</use>' +
                                '</svg>' +
                                'Withdraw </span>' +
                                '<span class="sr-only">Opens dialog</span>' +
                                '<span ng-if="!row.entity.isWithdrawLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // FollowUp 
                                '<a style="color:rgb(198, 54, 99);" aria-label="Coordination" title="Coordination" ng-if="row.entity.canFollowUp" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onFollowUpTouchend(row)" ' +
                                'ng-click="grid.appScope.onFollowUpClick(row)" >' +
                                '<span ng-if="row.entity.isFollowUpLoaded"><svg  focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-document">' +
                                '</use>' +
                                '</svg>' +
                                'Coordination</span>' +
                                '<span class="sr-only">Opens dialog</span>' +
                                '<span ng-if="!row.entity.isFollowUpLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // Print
                                '<a style="color:rgb(198, 54, 99);" aria-label="Download" title="Download" ng-if="row.entity.canPrint" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onPrintTouchend(row)" ' +
                                'ng-click="grid.appScope.onPrintClick(row)" >' +
                                '<span ng-if="row.entity.isPrintLoaded"><svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon icon_print">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-print"></use>' +
                                '</svg>' +
                                'Download</span> ' +
                                '<span ng-if="!row.entity.isPrintLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // Assign
                                '<a style="color:rgb(198, 54, 99);" aria-label="{{grid.appScope.assignLabel(row)}}" title="{{grid.appScope.assignLabel(row)}}" ng-if="row.entity.canAssign" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onAssignTouchend(row)" ' +
                                'ng-click="grid.appScope.onAssignClick(row)" >' +
                                '<span ng-if="row.entity.isAssignLoaded"><svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-check"></use>' +
                                '</svg>' +
                                '{{grid.appScope.assignLabel(row)}}</span> ' +
                                '<span ng-if="!row.entity.isAssignLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // Re-open
                                '<a style="color:rgb(198, 54, 99);" aria-label="Re-open" title="Re-open" ng-if="row.entity.canReOpen" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onReOpenTouchend(row)" ' +
                                'ng-click="grid.appScope.onReOpenIncidentClick(row)" >' +
                                '<span ng-if="row.entity.isReOpenLoaded"><svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-check"></use>' +
                                '</svg>' +
                                'Re-open</span> ' +
                                '<span ng-if="!row.entity.isReOpenLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // Link
                                '<a style="color:rgb(198, 54, 99);" aria-label="Link" title="Link" ng-if="row.entity.canLink" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onLinkTouchend(row)" ' +
                                'ng-click="grid.appScope.onLinkClick(row)" >' +
                                '<span ng-if="row.entity.isLinkLoaded"><svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-check"></use>' +
                                '</svg>' +
                                'Link</span> ' +
                                '<span ng-if="!row.entity.isLinkLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' :
                                //DFFH starts from here
                                //View
                                '<a style="color:rgb(0, 175, 188);" aria-label="View" title="View" ng-if="!row.entity.canEdit" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onViewOrEditTouchend(row)" ' +
                                'ng-click="grid.appScope.onViewOrEditClick(row)">' +
                                '<span ng-if="row.entity.isViewOrEditLoaded"><svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon icon_view">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-view">' +
                                '</use>' +
                                '</svg>' +
                                'View</span>' +
                                '<span class="sr-only">Opens dialog</span>' +
                                '<span ng-if="!row.entity.isViewOrEditLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // Edit
                                '<a style="color:rgb(0, 175, 188);" aria-label="Edit" title="Edit" ng-if="row.entity.canEdit" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onViewOrEditTouchend(row)" ' +
                                'ng-click="grid.appScope.onViewOrEditClick(row)">' +
                                '<span ng-if="row.entity.isViewOrEditLoaded"><svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon icon_edit">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-edit">' +
                                '</use>' +
                                '</svg>' +
                                'Edit</span>' +
                                '<span class="sr-only">Opens dialog</span>' +
                                '<span ng-if="!row.entity.isViewOrEditLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // Withdraw
                                '<a style="color:rgb(0, 175, 188);" aria-label="Withdraw" title="Withdraw" ng-if="row.entity.canWithdraw" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onWithdrawTouchend(row)" ' +
                                'ng-click="grid.appScope.onWithdrawClick(row)" >' +
                                '<span ng-if="row.entity.isWithdrawLoaded"><svg  focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon icon_delete">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-delete">' +
                                '</use>' +
                                '</svg>' +
                                'Withdraw </span>' +
                                '<span class="sr-only">Opens dialog</span>' +
                                '<span ng-if="!row.entity.isWithdrawLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // FollowUp 
                                '<a style="color:rgb(0, 175, 188);" aria-label="Coordination" title="Coordination" ng-if="row.entity.canFollowUp" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onFollowUpTouchend(row)" ' +
                                'ng-click="grid.appScope.onFollowUpClick(row)" >' +
                                '<span ng-if="row.entity.isFollowUpLoaded"><svg  focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-document">' +
                                '</use>' +
                                '</svg>' +
                                'Coordination</span>' +
                                '<span class="sr-only">Opens dialog</span>' +
                                '<span ng-if="!row.entity.isFollowUpLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // Print
                                '<a style="color:rgb(0, 175, 188);" aria-label="Download" title="Download" ng-if="row.entity.canPrint" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onPrintTouchend(row)" ' +
                                'ng-click="grid.appScope.onPrintClick(row)" >' +
                                '<span ng-if="row.entity.isPrintLoaded"><svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon icon_print">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-print"></use>' +
                                '</svg>' +
                                'Download</span> ' +
                                '<span ng-if="!row.entity.isPrintLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // Assign
                                '<a style="color:rgb(0, 175, 188);" aria-label="{{grid.appScope.assignLabel(row)}}" title="{{grid.appScope.assignLabel(row)}}" ng-if="row.entity.canAssign" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onAssignTouchend(row)" ' +
                                'ng-click="grid.appScope.onAssignClick(row)" >' +
                                '<span ng-if="row.entity.isAssignLoaded"><svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-check"></use>' +
                                '</svg>' +
                                '{{grid.appScope.assignLabel(row)}}</span> ' +
                                '<span ng-if="!row.entity.isAssignLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // Re-open
                                '<a style="color:rgb(0, 175, 188);" aria-label="Re-open" title="Re-open" ng-if="row.entity.canReOpen" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onReOpenTouchend(row)" ' +
                                'ng-click="grid.appScope.onReOpenIncidentClick(row)" >' +
                                '<span ng-if="row.entity.isReOpenLoaded"><svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-check"></use>' +
                                '</svg>' +
                                'Re-open</span> ' +
                                '<span ng-if="!row.entity.isReOpenLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>' +
                                // Link
                                '<a style="color:rgb(0, 175, 188);" aria-label="Link" title="Link" ng-if="row.entity.canLink" ng-focus="grid.appScope.selectRow(row)" href="javascript:void(0)" ' +
                                'role="button" ' +
                                'ng-touchend="grid.appScope.onLinkTouchend(row)" ' +
                                'ng-click="grid.appScope.onLinkClick(row)" >' +
                                '<span ng-if="row.entity.isLinkLoaded"><svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon">' +
                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-check"></use>' +
                                '</svg>' +
                                'Link</span> ' +
                                '<span ng-if="!row.entity.isLinkLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                '</a>',
                            visible: true,
                            width: isRunningInExtraSmallScreen ? '300' : '340',
                            resizable: false,
                            enableColumnMenu: false
                        },
                    ];
                };
                $scope.gridOptions = {
                    enableSorting: true,
                    enableFiltering: false,
                    enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
                    enableVerticalScrollbar: uiGridConstants.scrollbars.ALWAYS,
                    enableRowSelection: true,
                    enableFullRowSelection: true,
                    enableRowHeaderSelection: false,
                    enableSelectAll: false,
                    multiSelect: false,
                    rowHeight: $scope.rowHeight,
                    enableExpandableRowHeader: false,
                    expandableRowTemplate: 'app/partials/core/expandableRowTemplate.html',
                    columnDefs: getColumnDefs(),
                    rowTemplate:
                        '<div ' +
                        'ng-dblclick="grid.appScope.onViewOrEditClick(row)" ' +
                        'ng-click="grid.appScope.selectRow(row)"> ' +
                        '<div ' +
                        'class="ui-grid-cell" ' +
                        'ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ' +
                        'ui-grid-cell ' +
                        'ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ' +
                        'style="cursor:pointer"> ' +
                        '</div>' +
                        '</div>',
                    onRegisterApi: function (gridApi) {
                        $scope.gridApi = gridApi;

                        // Returns the number of rows currently in the grid
                        var rowsRendered = function () {
                            $scope.filteredRecords = $scope.gridApi.core.getVisibleRows($scope.gridApi.grid).length;
                        }
                        $scope.gridApi.core.on.rowsRendered($scope, rowsRendered);
                        $scope.gridApi.expandable.on.rowExpandedStateChanged($scope, function (row) {
                            $timeout(function () {
                                row.expandedRowHeight = $scope.getSubGridRowHeight(row);
                            }, 0);
                        });
                    }
                };

                $scope.selectRow = function (row) {
                    $timeout(function () {
                        $scope.gridApi.selection.selectRow(row.entity);
                    }, 50);
                }

                $scope.assignLabel = function (row) {
                    return row.entity.isAlreadyAssignedToCurrentUserRole ? "Re-assign" : "Assign";
                }

                $scope.onLinkTouchend = function (row) {
                    $timeout(function () {
                        linkFeedback(row);
                    }, 100);
                };
                $scope.onLinkClick = function (row) {
                    if (!iosOrMobile) {
                        linkFeedback(row);
                    }
                };

                var linkFeedback = function (row) {

                    var loadFeedbackLinkingData = function (feedback) {
                        return DataServices.getLinkableFeedbacks(feedback.feedbackId)
                            .then(function (data) {
                                var feedbackLinkingData = {
                                    feedback: feedback,
                                    linkableFeedbacks: data.linkableFeedbacks
                                        .map(function (linkableFeedback) {
                                            return {
                                                code: linkableFeedback.feedbackId,
                                                text: linkableFeedback.formattedRef,
                                                matchingText: linkableFeedback.ref.toString()
                                            };
                                        })
                                };
                                return feedbackLinkingData;
                            },
                                function (data) {
                                    $scope.utility.showNotification(true, 'internalError');
                                    throw new Error(data);
                                });
                    };

                    var chooseFeedbackLink = function (feedbackLinkingData) {
                        DataServices.configData.optionSets['linkableprivacyincidents'] = feedbackLinkingData.linkableFeedbacks;
                        return $scope.utility.openPopup('linkPrivacyIncident', feedbackLinkingData.feedback).result
                            .then(function (data) {
                                $scope.currentLoadMessage = Constants.Messages.linkPrivacyProgress;
                                var linkedFeedbackId = data.outParams.linkablePrivacyIncidents.code;
                                var linkReason = $scope.utility.getOptionSetText('privacylinkreasons', data.outParams.linkReason);
                                //var linkReason = data.outParams.linkReason;
                                var feedbackLink = {
                                    feedback: feedbackLinkingData.feedback,
                                    linkedFeedbackId: linkedFeedbackId,
                                    linkReason: linkReason
                                };
                                return feedbackLink;
                            });
                    };

                    var saveFeedbackLink = function (feedbackLink) {
                        return DataServices.saveFeedbackLink({
                            feedbackId1: feedbackLink.feedback.feedbackId,
                            feedbackId2: feedbackLink.linkedFeedbackId,
                            linkReason: feedbackLink.linkReason
                        })
                            .then(function () {
                                DataServices.trackEventsWithGA('PageName: Manage Complaints', 'Link Successful', 'Link');
                            }, function (data) {
                                DataServices.trackEventsWithGA('PageName: Manage Complaints', 'Link Failed', 'Link');
                                $scope.utility.showNotification(true, 'internalError');
                                throw new Error(data);
                            });
                    };

                    DataServices.trackEventsWithGA('PageName: Link Complaints', 'Click Link', 'Link');
                    var feedback = row.entity;
                    feedback.isLinkLoaded = false;
                    loadFeedbackLinkingData(feedback)
                        .then(function (feedbackLinkingData) {
                            return chooseFeedbackLink(feedbackLinkingData);
                        })
                        .then(function (feedbackLink) {
                            return saveFeedbackLink(feedbackLink);
                        })
                        .then(function () {
                            getFeedbacks(true);
                        })
                        .finally(function () {
                            feedback.isLinkLoaded = true;
                        });
                };

                var reOpenIncident = function (row) {
                    //TODO: display confirmation popup 
                    $scope.utility.openPopup('reopenIncident', null).result.then(function (result) {
                        row.entity.isReOpenLoaded = false;
                        var params = row.entity;
                        DataServices
                            .reOpenFeedback(row.entity.feedbackId, row.entity.lastUpdatedTime)
                            .then(function (response) {
                                if (response !== null && response.data.status) {
                                    if (response.data.status == 3) {
                                        $scope.utility.showNotification(true, 'reopenIncidentSuccessful', params);
                                        DataServices.trackEventsWithGA('Re-open action in Manage Report', 'Click Re-open Report', 'Successful Re-open Report.');
                                    }
                                    else if (response.data.status == 2) {
                                        $scope.utility.showNotification(true, 'incidentUpdatedSinceReadTime', params);
                                    }
                                    else {
                                        $scope.utility.showNotification(true, 'reopenIncidentFailed');
                                    }
                                    row.entity.isReOpenLoaded = true;
                                    //refreshes the grid
                                    getFeedbacks(true);
                                }
                            }, function (error) {
                                $scope.utility.showNotification(true, 'internalError');
                                row.entity.isReOpenLoaded = true;
                            });
                    });
                }

                $scope.onReOpenTouchend = function (row) {
                    $timeout(function () {
                        reOpenIncident(row);
                    }, 100);
                };

                $scope.onReOpenIncidentClick = function (row) {
                    if (!iosOrMobile) {
                        reOpenIncident(row);
                    }
                }

                $scope.onClientExpandTouchend = function (row) {
                    $timeout(function () {
                        clientExpand(row);
                    }, 100);
                };

                var viewOrEditFeedback = function (row) {
                    row.entity.isViewOrEditLoaded = false;

                    // Assign response info details (the ones available before retrieving the record from the server)
                    DataServices.responseInfo.incidentId = row.entity.feedbackId;
                    DataServices.responseInfo.incidentRef = row.entity.ref;
                    DataServices.responseInfo.status = row.entity.statusId;
                    DataServices.responseInfo.statusText = row.entity.statusDisplayName;

                    // Set current incident as editable or not
                    $scope.utility.setCurrentIncidentAsEditable(row.entity.canEdit);

                    var action = row.entity.canEdit ? 'Edit' : 'View';
                    DataServices.trackEventsWithGA('PageName: Manage Reports', 'Click ' + action + ' Report', action + ' Report');

                    DataServices.getFeedbackById(row.entity.feedbackId)
                        .then(function (data) {

                            // Set original response (used to compare on save)
                            DataServices.originalResponse = JSON.parse(data.response);

                            // Assign response info details (the ones available after retrieving the record from the server)
                            DataServices.responseInfo.responses = JSON.parse(data.response);
                            DataServices.responseInfo.lastUpdatedTime = data.lastUpdatedTime;
                            DataServices.responseInfo.template = data.templateId;
                            DataServices.responseInfo.versionNumber = data.templateVersion;
                            DataServices.validatedPages = DataServices.determineValidatedPages(data.response);

                            DataServices.getConfigurationUsingCache(data.templateId, data.templateVersion, row.entity.feedbackId, DataServices.isAuthenticated())
                                .then(function (data) {
                                    $rootScope.allowFormNavigation = true;
                                    $location.path(Constants.Url.firstIncidentFormPage);

                                }, function (data) {
                                    $scope.utility.showNotification(true, 'internalError');
                                });

                        }, function (data) {
                            $scope.utility.showNotification(true, 'internalError');
                        });

                    row.entity.isViewOrEditLoaded = true;
                };
                $scope.onViewOrEditTouchend = function (row) {
                    $timeout(function () {
                        viewOrEditFeedback(row);
                    }, 100);
                };
                $scope.onViewOrEditClick = function (row) {
                    if (!iosOrMobile) {
                        viewOrEditFeedback(row);
                    }
                };

                var withdrawFeedback = function (row) {

                    var params = row.entity;
                    $scope.utility.openPopup('withdrawIncident', params).result.then(function (result) {

                        row.entity.isWithdrawLoaded = false;
                        $scope.currentLoadMessage = "Withdrawing Report";

                        var withdrawalReason = $scope.utility.getOptionSetText('withdrawalreasons', result.outParams.withdrawalReason);

                        DataServices
                            .withdrawFeedback(row.entity.feedbackId, withdrawalReason, row.entity.lastUpdatedTime)
                            .then(function (response) {

                                if (response !== null && response.data.status) {

                                    if (response.data.status == 1) {
                                        $scope.utility.showNotification(true, 'withDrawIncidentFailed', params);
                                        DataServices.trackEventsWithGA('Withdraw action in Manage Reports',
                                            'Click Withdraw Report',
                                            'Failed to Withdraw Report.');
                                    } else if (response.data.status == 2) {
                                        $scope.utility.showNotification(true, 'withdrawnByAnotherUser', params);
                                    } else if (response.data.status == 3) {
                                        $scope.utility.showNotification(true, 'withdrawnIncidentSuccessful', params);
                                    }

                                    //stop showing the spinner
                                    row.entity.isWithdrawLoaded = true;

                                    //refreshes the grid
                                    getFeedbacks(true);

                                    DataServices.trackEventsWithGA('Withdraw action in Manage Report',
                                        'Click Withdraw Report',
                                        'Successful Withdraw Report.');
                                } else {
                                    $scope.utility.showNotification(true, 'internalError');
                                    //stop showing the spinner
                                    row.entity.isWithdrawLoaded = true;
                                }
                            }, function () {
                                //on error  stop showing the spinner
                                $scope.utility.showNotification(true, 'withDrawIncidentFailed', params);
                                DataServices.trackEventsWithGA('Withdraw action in Manage Report',
                                    'Click Withdraw Report',
                                    'Failed to Withdraw Report.');
                                row.entity.isWithdrawLoaded = true;
                            });
                    });
                };

                $scope.onWithdrawTouchend = function (row) {
                    $timeout(function () {
                        withdrawFeedback(row);
                    }, 100);
                };
                $scope.onWithdrawClick = function (row) {
                    if (!iosOrMobile) {
                        withdrawFeedback(row);
                    }
                };

                var followUpFeedback = function (row) {
                    row.entity.isFollowUpLoaded = false;

                    // Reset original response (used to compare on save)
                    DataServices.originalResponse = {};
                    DataServices.resetResponseInfo();
                    DataServices.responseInfo.responses = {};
                    DataServices.responseInfo.status = 1;

                    DataServices.responseInfo.incidentId = row.entity.feedbackId;
                    DataServices.responseInfo.incidentRef = row.entity.ref;
                    DataServices.responseInfo.statusText = row.entity.statusDisplayName;
                    DataServices.responseInfo.incidentDate = row.entity.incidentDate;
                    DataServices.responseInfo.feedbackAssignments = row.entity.assigneeArray;

                    // adding template information to use in next page submit
                    DataServices.responseInfo.template = row.entity.templateId;

                    DataServices.trackEventsWithGA('PageName: Manage Reports', 'Click Coordination', 'Coordination');

                    DataServices.getConfigurationUsingCache(Constants.ConfigTemplate.incidentCoordination, null, null, DataServices.isAuthenticated())
                        .then(function (data) {
                            $location.path(Constants.Url.firstFollowUpFormPage);
                        }, function (data) {
                            $scope.utility.showNotification(true, 'internalError');
                        });

                };
                $scope.onFollowUpTouchend = function (row) {
                    $timeout(function () {
                        followUpFeedback(row);
                    }, 100);
                };
                $scope.onFollowUpClick = function (row) {
                    if (!iosOrMobile) {
                        followUpFeedback(row);
                    }
                };

                var printFeedback = function (row) {
                    downloadPdf(row);
                };
                $scope.onPrintTouchend = function (row) {
                    $timeout(function () {
                        printFeedback(row);
                    }, 100);
                };
                $scope.onPrintClick = function (row) {
                    if (!iosOrMobile) {
                        printFeedback(row);
                    }
                };

                var assignFeedback = function (row) {

                    var loadAssignmentData = function (feedback) {
                        return DataServices.getFeedbackAssignees(feedback.feedbackId, $scope.IsDHVisible)
                            .then(function (data) {
                                var assignmentData = {
                                    feedback: feedback,
                                    assignerRoleId: data.assignerRoleId,
                                    assignableUsers: data.assignableUsers
                                        .map(function (au) {
                                            return {
                                                code: au.user.id,
                                                text: au.user.fullName,
                                                roleId: au.roleId
                                            };
                                        })
                                };
                                return assignmentData;
                            },
                                function (data) {
                                    $scope.utility.showNotification(true, 'internalError');
                                    throw new Error(data);
                                });
                    };

                    var chooseFeedbackAssignee = function (assignmentData) {
                        DataServices.configData.optionSets['incidentassignees'] = assignmentData.assignableUsers;
                        return $scope.utility.openPopup('assignIncident', assignmentData.feedback).result
                            .then(function (data) {
                                $scope.currentLoadMessage = "Assigning Report";
                                var assigneeUserId = data.outParams.incidentAssignee.code;
                                var assigneeRoleId = data.outParams.incidentAssignee.roleId;
                                var feedbackAssignee = {
                                    feedback: assignmentData.feedback,
                                    assignerRoleId: assignmentData.assignerRoleId,
                                    assigneeRoleId: assigneeRoleId,
                                    assigneeUserId: assigneeUserId
                                };
                                return feedbackAssignee;
                            });
                    };

                    var saveFeedbackAssignee = function (feedbackAssignee) {
                        return DataServices.assignFeedback({
                            feedbackId: feedbackAssignee.feedback.feedbackId,
                            feedbackTypeId: Constants.FeedbackType.Privacy,
                            assignerRoleId: feedbackAssignee.assignerRoleId,
                            roleId: feedbackAssignee.assigneeRoleId,
                            userId: feedbackAssignee.assigneeUserId
                        })
                            .then(function () {
                                DataServices.trackEventsWithGA('PageName: Manage Reports', 'Assign Successful', 'Assign');
                                $scope.utility.showNotification(true, 'incidentAssignmentSuccessful', feedbackAssignee.feedback);
                            }, function (data) {
                                DataServices.trackEventsWithGA('PageName: Manage Reports', 'Assign Failed', 'Assign');
                                $scope.utility.showNotification(true, 'incidentAssignmentFailed', feedbackAssignee.feedback);
                                throw new Error(data);
                            });
                    };

                    DataServices.trackEventsWithGA('PageName: Manage Reports', 'Click Assign', 'Assign');
                    var feedback = row.entity;
                    feedback.isAssignLoaded = false;
                    loadAssignmentData(feedback)
                        .then(function (assignmentData) {
                            return chooseFeedbackAssignee(assignmentData);
                        })
                        .then(function (feedbackAssignee) {
                            return saveFeedbackAssignee(feedbackAssignee);
                        })
                        .then(function () {
                            getFeedbacks(true);
                        })
                        .finally(function () {
                            feedback.isAssignLoaded = true;
                        });
                };
                $scope.onAssignTouchend = function (row) {
                    $timeout(function () {
                        assignFeedback(row);
                    }, 100);
                };
                $scope.onAssignClick = function (row) {
                    if (!iosOrMobile) {
                        assignFeedback(row);
                    }
                };

                var clientExpand = function (row) {
                    $scope.utility.openPopup('clientNames', { names: row.entity.sortedClientNameArray, incidentId: row.entity.ref });
                }
                $scope.onClientExpandTouchend = function (row) {
                    $timeout(function () {
                        clientExpand(row);
                    }, 100);
                };
                $scope.onClientExpandClick = function (row) {
                    if (!iosOrMobile) {
                        clientExpand(row);
                    }
                };

                var goToLinkedFeedback = function (row) {
                    var feedbackLink = row.entity;
                    var match = function (item) {
                        return item.feedbackId.toLowerCase() === feedbackLink.feedbackId.toLowerCase();
                    };
                    var tryViewOrEditFeedback = function (feedback) {
                        if (feedback && (feedback.canEdit || feedback.canAccess)) {
                            viewOrEditFeedback({ entity: feedback });
                        } else {
                            $scope.utility.openPopup('incidentNotAccessible', { formattedRef: feedbackLink.formattedRef });
                        }
                    }
                    var feedbackFromDashboard = $scope.gridOptions.data.filter(match)[0];
                    if (feedbackFromDashboard) {
                        tryViewOrEditFeedback(feedbackFromDashboard);
                    } else {
                        $scope.utility.setElementVisibility('pageLoad', true);
                        DataServices.getFeedbacks({
                            feedbackTypeId: feedbackLink.feedbackTypeId,
                            searchTerm: feedbackLink.formattedRef,
                            showAllFeedbacks: true
                        })
                            .then(function (data) {
                                var feedbackFromDatabase = ((data && data.feedbacks) || []).filter(match)[0];
                                tryViewOrEditFeedback(feedbackFromDatabase);
                            },
                                function (data) {
                                    $scope.utility.showNotification(true, 'internalError');
                                })
                            .finally(function () {
                                $scope.utility.setElementVisibility('pageLoad', false);
                            })
                    }
                };

                $scope.onGoToLinkedFeedbackTouchend = function (row) {
                    $timeout(function () {
                        goToLinkedFeedback(row);
                    }, 100);
                };
                $scope.onGoToLinkedFeedbackClick = function (row) {
                    if (!iosOrMobile) {
                        goToLinkedFeedback(row);
                    }
                };

                $scope.refresh = function () {
                    getFeedbacks(true);
                }

                $scope.createFeedback = function () {
                    if (!DataServices.isSessionActive()) {
                        adalAuthenticationService.login();
                        return false;
                    }
                    // Reset original response (used to compare on save)
                    DataServices.originalResponse = {};
                    DataServices.resetResponseInfo();
                    DataServices.responseInfo.responses = {};
                    DataServices.responseInfo.status = 1;

                    // Set current incident as editable or not
                    $scope.utility.setCurrentIncidentAsEditable(true);

                    DataServices.trackEventsWithGA('PageName: Manage Reports', 'Click Create New Report', 'Create New Report');

                    DataServices.getConfigurationUsingCache(Constants.ConfigTemplate.incident, null, null, DataServices.isAuthenticated())
                        .then(function (data) {
                            $rootScope.allowFormNavigation = true;
                            $location.path(Constants.Url.firstIncidentFormPage);
                        }, function (data) {
                            $scope.utility.showNotification(true, 'internalError');
                        });
                }

                // Refresh the incident grid based on selected filter values
                $scope.filterRecords = function () {
                    $scope.gridOptions.data.length = 0;
                    getFeedbacks(true);
                }

                $scope.clearAllFilters = function () {
                    $scope.gridOptions.data.length = 0;
                    $scope.filters.selectedFeedbackStatus = Constants.defaultFeedbackStatus;
                    $scope.filters.selectedFinalRiskRating = '';
                    $scope.filters.selectedArea = '';
                    $scope.filters.selectedProgram = '';
                    $scope.filters.selectedDateRange = Constants.defaultDateOption;
                    $scope.filters.searchPhrase = '';
                    getFeedbacks(true);
                }



                $scope.canCreateFeedback = function () {
                    return true; // any user can create a new feedback
                }

                var removeFeedbackLink = function (row) {
                    row.entity.isRemoveFeedbackLinkLoaded = false;
                    return DataServices.removeFeedbackLink({
                        feedbackId1: row.entity.feedbackId,
                        feedbackId2: row.grid.parentRow.entity.feedbackId
                    })
                        .then(function () {
                            DataServices.trackEventsWithGA('PageName: Manage Privacy', 'Remove Feedback Link Successful', 'Remove Feedback Link');
                            getFeedbacks(true);
                        }, function (data) {
                            DataServices.trackEventsWithGA('PageName: Manage Privacy', 'Remove Feedback Link Failed', 'Remove Feedback Link');
                            $scope.utility.showNotification(true, 'internalError');
                        })
                        .finally(function () {
                            row.entity.isRemoveFeedbackLinkLoaded = true;
                        });
                };

                $scope.onRemoveFeedbackLinkTouchend = function (row) {
                    $timeout(function () {
                        removeFeedbackLink(row);
                    }, 100);
                };

                $scope.onRemoveFeedbackLinkClick = function (row) {
                    if (!iosOrMobile) {
                        removeFeedbackLink(row);
                    }
                };

                $scope.canExtractCsv = function () {
                    return true;
                }

                $scope.extractCsv = function () {
                    var feedbackType = 1;
                    $scope.utility.showNotification(true, 'csvExtractInProgress');
                    var isDOH = $scope.IsDHVisible;
                    var dateRangeId = $scope.filters.selectedDateRange === '' ? null : $scope.filters.selectedDateRange;
                    DataServices.extractCsv(dateRangeId, feedbackType, isDOH).then(function (response) {
                        var file = new Blob([response.data], { type: 'text/csv' });
                        saveAs(file, 'PrivacyCsvExtract.csv');
                        $scope.utility.showNotification(false, 'csvExtractInProgress');
                        $scope.utility.showNotification(true, 'csvExtractCompletedSuccessfully');
                    }, function (error) {
                        $scope.utility.showNotification(true, 'csvExtractError');
                    });
                }


                var overdueVirtualStatus = { code: 'overdue', text: 'Overdue' };
                var activeVirtualStatus = { code: 'active', text: 'Active' };

                var getRequestData = function () {
                    // We should ONLY be requesting either an actual known status, records that are "active", records that
                    // are "overdue" or not specifying a status to search by.
                    var isStatusFilterShowAll = $scope.filters.selectedFeedbackStatus === '';
                    var isStatusFilterOverdue = $scope.filters.selectedFeedbackStatus === overdueVirtualStatus.code;
                    var isStatusFilterActive = $scope.filters.selectedFeedbackStatus === activeVirtualStatus.code;

                    return {
                        feedbackTypeId: Constants.FeedbackType.Privacy,
                        searchTerm: $scope.filters.searchPhrase === '' ? null : $scope.filters.searchPhrase,
                        statusId: (isStatusFilterShowAll || isStatusFilterActive || isStatusFilterOverdue) ? null : $scope.filters.selectedFeedbackStatus,
                        isActive: isStatusFilterActive,
                        isDOH: $scope.IsDHVisible,
                        isOverdue: isStatusFilterOverdue,
                        finalRiskRating: $scope.filters.selectedFinalRiskRating === '' ? null : $scope.filters.selectedFinalRiskRating,
                        areaId: $scope.filters.selectedArea === '' ? null : $scope.filters.selectedArea,
                        programId: $scope.filters.selectedProgram === '' ? null : $scope.filters.selectedProgram,
                        dateRangeId: $scope.filters.selectedDateRange === '' ? null : $scope.filters.selectedDateRange
                    };
                }

                var downloadPdf = function (row) {
                    //var standalone = window.navigator.standalone;
                    //var userAgent = window.navigator.userAgent.toLowerCase();
                    //var safari = /safari/.test(userAgent);
                    //var ios = /iphone|ipod|ipad/.test(userAgent);
                    row.entity.isPrintLoaded = false;
                    DataServices.viewAllFormsPdf(row.entity.feedbackId)
                        .then(function (response) {
                            var data = response && response.data;
                            try {
                                var file = new Blob([data], { type: "application/pdf" }, { name: row.entity.formattedRef });
                                saveAs(file, row.entity.formattedRef + '.pdf');
                                row.entity.isPrintLoaded = true;
                            }
                            catch (e) {
                                $scope.utility.openPopup('errorDownloadDoc');
                                row.entity.isPrintLoaded = true;
                            }
                        }, function () {
                            $scope.utility.openPopup('errorDownloadDoc');
                            row.entity.isPrintLoaded = true;
                        });
                };

                var getFeedbacks = function (showSpinner) {

                    if (showSpinner) {
                        $scope.utility.setElementVisibility('pageLoad', true);
                        $scope.utility.toggleLoadingSpinner(true);
                    }

                    var loadGridData = function (data) {
                        var feedbacks = (data && data.feedbacks) || [];

                        $scope.totalRecords = (data && data.totalRecords) || 0;
                        $scope.filteredRecords = feedbacks.length;
                        $scope.maxRecords = (data && data.maxRecords) || 0;
                        $scope.hasMoreRecords = !!(data && data.hasMoreRecords);

                        getOptions('incidentstatus-privacy').then(function (result) {
                            $scope.filters.feedbackStatusList = result.slice();
                            $scope.filters.feedbackStatusList.push(activeVirtualStatus);
                            $scope.filters.feedbackStatusList.push(overdueVirtualStatus);
                        })
                      
                        getOptions('riskrating').then(function (result) {
                            $scope.filters.finalRiskRatingList = result;
                        });
                        getOptions('dhhsservicearea').then(function (result) {
                            $scope.filters.areaList = result;
                        });
                        getOptions('dhhsprogram').then(function (result) {
                            $scope.filters.programList = result;
                        });
                        getOptions('daterangefilter').then(function (result) {
                            $scope.filters.dateRangeList = result;
                            $scope.$apply();
                        });

                        var riskRatingDecodeMap = $scope.utility.getOptionSetDecodeMap($scope.filters.finalRiskRatingList);

                        angular.forEach(feedbacks,
                            function (row) {
                                row.isCloseLoaded = true;
                                row.isViewOrEditLoaded = true;
                                row.isWithdrawLoaded = true;
                                row.isFollowUpLoaded = true;
                                row.isPrintLoaded = true;
                                row.isAssignLoaded = true;
                                row.isReOpenLoaded = true;
                                row.isLinkLoaded = true;

                                row.clientName = row.sortedClientNameArray[0];
                                row.clientCount = row.sortedClientNameArray.length;
                                row.initialRiskRatingDescription = riskRatingDecodeMap[row.initialRiskRating];
                                row.finalRiskRatingDescription = riskRatingDecodeMap[row.finalRiskRating];

                                angular.forEach(row.linkArray,
                                    function (subRow) {
                                        subRow.isRemoveFeedbackLinkLoaded = true;
                                    });
                                row.subGridOptions = {
                                    enableSorting: true,
                                    enableFiltering: false,
                                    enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
                                    enableVerticalScrollbar: uiGridConstants.scrollbars.ALWAYS,
                                    enableRowSelection: true,
                                    enableFullRowSelection: true,
                                    enableRowHeaderSelection: false,
                                    enableSelectAll: false,
                                    multiSelect: false,
                                    rowHeight: $scope.rowHeight,
                                    columnDefs: [
                                        {
                                            field: 'removeLink',
                                            displayName: '',
                                            enableHiding: false,
                                            enableColumnMenu: false,
                                            width: $scope.isRunningInExtraSmallScreen ? '30%' : '10%',
                                            cellTemplate: '<div class="ui-grid-cell-contents">' +
                                                '<a aria-label="Remove link" title="Remove link" href="" ' +
                                                'role="button" ' +
                                                'ng-touchend="grid.parentRow.grid.appScope.onRemoveFeedbackLinkTouchend(row)" ' +
                                                'ng-click="grid.parentRow.grid.appScope.onRemoveFeedbackLinkClick(row)" >' +
                                                '<span ng-if="row.entity.isRemoveFeedbackLinkLoaded"> ' +
                                                '<svg focusable="false" viewBox="0 0 16 16" width="16" height="16" class="icon icon_delete">' +
                                                '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-delete">' +
                                                '</use>' +
                                                '</svg>' +
                                                'Remove</span>' +
                                                '<span ng-if="!row.entity.isRemoveFeedbackLinkLoaded" class="loader"><span class="loader__mask"><span class="loader__circle"></span></span></span>' +
                                                '</a>' +
                                                '</div>'
                                        },
                                        {
                                            field: 'formattedRef',
                                            displayName: 'Report Id',
                                            enableHiding: false,
                                            enableColumnMenu: false,
                                            sort: { direction: uiGridConstants.ASC },
                                            width: $scope.isRunningInExtraSmallScreen ? '30%' : '10%',
                                            cellTemplate: '<div class="ui-grid-cell-contents">' +
                                                '<a href="" ' +
                                                'role="button" ' +
                                                'ng-touchend="grid.parentRow.grid.appScope.onGoToLinkedFeedbackTouchend(row)" ' +
                                                'ng-click="grid.parentRow.grid.appScope.onGoToLinkedFeedbackClick(row)" >' +
                                                '{{COL_FIELD}}' +
                                                '</a>' +
                                                '</div>'
                                        },
                                        {
                                            field: 'linkReason',
                                            displayName: 'Link Reason',
                                            enableHiding: false,
                                            enableColumnMenu: false,
                                            width: $scope.isRunningInExtraSmallScreen ? '40%' : '80%'
                                        }
                                    ],
                                    data: row.linkArray
                                };

                            });

                        $scope.gridOptions.data = feedbacks;
                    };

                    if (showSpinner) {
                        $scope.utility.setElementVisibility('pageLoad', true);
                    }
                    DataServices.getFeedbacks(getRequestData())
                        .then(function (data) {
                            loadGridData(data);
                        },
                            function (data) {
                                $scope.utility.showNotification(true, 'internalError');
                            })
                        .finally(function () {
                            if (showSpinner) {
                                $scope.utility.setElementVisibility('pageLoad', false);
                            }
                            $scope.utility.toggleLoadingSpinner(false);
                        });
                };

                $scope.utility.setElementVisibility('pageLoad', true);
                $scope.utility.toggleLoadingSpinner(true);

                function getOptions(optionset) {
                    return ($scope.utility.getOptionSetFromConfiguration(optionset, Constants.ConfigTemplate.incident));
                }

                DataServices.getConfigurationUsingCache(Constants.ConfigTemplate.incident, null, null, DataServices.isAuthenticated())
                    .then(function (data) {
                        DataServices.responseInfo.role = data.role;
                        getFeedbacks(false);
                    }, function (data) {
                        $scope.utility.showNotification(true, 'internalError');
                    })
                    .finally(function () {
                        $scope.utility.setElementVisibility('pageLoad', false);
                        $scope.utility.toggleLoadingSpinner(false);
                    });

                // Report the virtual page visit to Google Analytics.
                DataServices.trackPageVisitWithGA('Landing Page: Manage Reports');
            }]);
}());